import React, { useCallback } from 'react';
import { Box, IconButton, CheckIcon } from '@cdl/heartbeat-react';
import { ClusterBeat } from '../../clustering.types';
import { useDispatch, useSelector } from 'react-redux';
import { selectBeats } from '../../thunks/select-beats.thunk';
import {
  isBeatHoveredSelector,
  isBeatSelectedSelector,
  beatsSelector,
} from '../../../beats/beats.selector';

interface Props {
  beat: ClusterBeat;
}

export const SelectBeat: React.FC<Props> = ({ beat }) => {
  const dispatch = useDispatch();
  const isSelected = useSelector(isBeatSelectedSelector(beat.id));
  const hovered = useSelector(isBeatHoveredSelector(beat.id));
  const beats = useSelector(beatsSelector);
  const selectBeat = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      if (beats.length > 1) {
        dispatch(
          selectBeats(beat.id, event.shiftKey, event.ctrlKey || event.metaKey),
        );
      }
    },
    [dispatch, beat.id, beats],
  );
  return (
    <Box display='flex' flex={1} alignItems='start' justifyContent='center'>
      {(isSelected || hovered) && (
        <IconButton
          variant='tertiary'
          size='sm'
          onClick={selectBeat}
          aria-label='Select beat'
          isActive={isSelected}
          icon={<CheckIcon />}
        />
      )}
    </Box>
  );
};
